import * as React from 'react';

const Panel = React.lazy(() => import('./container'));

export default () => <Panel />;
